import { Tooltip as MuiTooltip } from "@mui/material";
import { ReactElement, ReactNode } from "react";

import { cn } from "../utils/styling";

type TooltipProps = {
  children: ReactElement;
  className?: string;
  title: ReactNode;
  tooltipClassName?: string;
};

export const Tooltip = ({ children, className, title, tooltipClassName }: TooltipProps) => {
  if (!children || !title) return null;
  return (
    <MuiTooltip
      classes={{
        tooltip: cn(
          "bg-lds-surface-bright p-2 text-lds-foreground-secondary shadow-xl font-ds-body-regular-xs",
          tooltipClassName
        ),
      }}
      className={cn(className)}
      title={title}
    >
      {children}
    </MuiTooltip>
  );
};
